import { Flex } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import TableHeaderRow from "./components/TableHeaderRow";
import TableItemRow from "./components/TableItemRow";
import TableTotalRow from "./components/TableTotalRow";
import { CobrancaContaDetailsItem } from "features/cobranca/typings";

export interface TableItemCobrancaProps {
  item: CobrancaContaDetailsItem;
  onChangeTaxas?: ({
    contaId,
    categoriaFinanceiraId,
    taxas,
  }: {
    contaId: string;
    categoriaFinanceiraId: string;
    taxas: { taxaMulta: number; taxaJuros: number; taxaCobranca: number };
  }) => any;
}

function TableItemCobranca({ item, onChangeTaxas }: TableItemCobrancaProps) {
  return (
    <Flex maxW="100%" flexDir="column">
      <Flex bg={colors.black75} gridGap={1} py={3} pr={6} fontWeight="medium">
        <TableHeaderRow />
      </Flex>
      <Flex w="100%" flexDir="column">
        {item?.composicoes.map((composicao, index) => (
          <Flex
            key={composicao.id}
            bg={index % 2 === 0 ? "white" : colors.black75}
            gridGap={1}
            py={3}
            pr={6}
          >
            <TableItemRow
              composicao={composicao}
              onChangeTaxas={(taxas) => {
                onChangeTaxas?.({
                  contaId: item.id,
                  categoriaFinanceiraId: composicao.categoriaFinanceiraId,
                  taxas,
                });
              }}
            />
          </Flex>
        ))}

        <Flex
          bg={item.composicoes.length % 2 === 0 ? "white" : colors.black75}
          gridGap={1}
          py={3}
          pr={6}
          fontWeight="bold"
          borderTopColor={colors.black200}
          borderTopWidth={1}
        >
          <TableTotalRow conta={item} />
        </Flex>
      </Flex>
    </Flex>
  );
}

export default TableItemCobranca;
